function messageFromBody(data) {
  if (!data || typeof data !== 'object') return null;
  var msg = data.message;
  if (Array.isArray(msg)) {
    var parts = msg.filter(function (m) {
      return typeof m === 'string';
    });
    return parts.length > 0 ? parts.join('. ') : null;
  }
  if (typeof msg === 'string' && msg.length > 0) return msg;
  return null;
}
function getResponseData(error) {
  if (typeof error !== 'object' || error === null || !('response' in error)) return undefined;
  var response = error.response;
  return response === null || response === void 0 ? void 0 : response.data;
}
/** Formats Nest/axios validation errors for display; falls back when unknown. */
export function formatApiErrorMessage(error, fallback) {
  var _a, _b;
  var responseData = getResponseData(error);
  if (responseData !== undefined) {
    return (_a = messageFromBody(responseData)) !== null && _a !== void 0 ? _a : fallback;
  }
  return (_b = messageFromBody(error)) !== null && _b !== void 0 ? _b : error instanceof Error && error.message ? error.message : fallback;
}